import { Col, Row } from "antd";
import { useContext, useEffect, useState } from "react";
import { useMoralis, useWeb3Transfer } from "react-moralis";

import { ButtonOne } from "../components/Buttons";
import { DataContext } from "../contexts/runesContext";
import QRLogo from "../assets/qr-code.png";
import QRScanner from "../components/QRScanner";

const Wallet = () => {
  const { contextData, setContextData } = useContext(DataContext);
  const { Moralis, account, isInitialized, isAuthenticated } = useMoralis();

  const [balance, setBalance] = useState(0);
  const [balanceNfts, setBalanceNfts] = useState();

  const [label, setLabel] = useState("tokens");
  const [onScanQR, setOnScanQR] = useState(false);
  const [amount, setAmount] = useState();
  const [toAddress, setToAddress] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [collection, setCollection] = useState("0xdbEe544476C696D01B61B17Be7e58BF1cEDC68fc");

  //Get matic mumbai polygon Balance
  const fetchBalance = async () => {
    const options = { chain: Moralis.Chains.POLYGON_MUMBAI };
    const balance = await Moralis.Web3API.account.getNativeBalance(options);
    setBalance(balance.balance / 10 ** 18);
  };
  //Show NFT given by owner moralis
  const fetchNFTs = async () => {
    const testnetNFTs = await Moralis.Web3API.account.getNFTs({
      chain: Moralis.Chains.POLYGON_MUMBAI,
    });
    setBalanceNfts(testnetNFTs.result);
  };
  useEffect(() => {
    async function fetchData() {
      await fetchBalance();
      await fetchNFTs();
    }
    fetchData();
  }, []);

  //sendRunes

  async function sendRunes(toAdd, amount) {
    if ((isInitialized, isAuthenticated)) {
      if (contextData.runes >= amount) {
        const runesTable = Moralis.Object.extend("Runes");
        const queryRunes = new Moralis.Query(runesTable);
        const queryRunesOwner = new Moralis.Query(runesTable);
        queryRunes.equalTo("ethAddress", toAdd);
        const dataRunes = await queryRunes.first();
        queryRunesOwner.equalTo("ethAddress", account);
        const dataRunesOwner = await queryRunesOwner.first();

        dataRunes.increment("runes", Number(amount));
        dataRunes.save();
        dataRunesOwner.decrement("runes", Number(amount));
        dataRunesOwner.save();
        setContextData({ runes: contextData.runes - amount });
      } else {
        console.log("Monto invalido");
      }
    } else {
      console.log("Error: Invalid session");
    }
  }

  //Transfer native token to another address
  const handleTransfer = async (amount) => {
    await Moralis.transfer({
      amount: Moralis.Units.ETH(amount),
      receiver: toAddress,
      type: "native",
    })
      .then((e) => {
        alert("sucesfully transfered");
      })
      .catch((e) => {
        alert(e, "Enter wallet address of the recipient");
      });
    await fetchBalance();
  };

  //Transfer nft token to another address
  const { fetch, error, isFetching } = useWeb3Transfer({
    type: "erc721",
    receiver: toAddress,
    contractAddress: collection,
    tokenId: tokenId,
  });
  //Nft Item Component
  const Item = (props) => {
    return (
      <div className="token-container">
        <div className="token-amount"> {props.amount}&nbsp;</div>
        <div className="token-symbol">{props.symbol} </div>
      </div>
    );
  };
  //Tokens Component
  const Tokens = () => {
    return (
      <div className="tokens">
        <h1>Tus tokens</h1>
        <div>
          {contextData.runes} OPIS <br />
          {parseFloat(balance)} MATIC <br />
        </div>
      </div>
    );
  };
  //Show list of nfts given by owner
  const Nfts = () => {
    console.log(balanceNfts);
    return (
      <div className="tokens">
        <h1>Tus NFT's</h1>
        <div>
          {balanceNfts && balanceNfts.lenght >= 0 ? (
            balanceNfts.map(({ token_hash, symbol, amount }) => (
              <Item key={token_hash} symbol={symbol} amount={amount} />
            ))
          ) : (
            <p>Aún no tienes ningún NFT</p>
          )}
        </div>
      </div>
    );
  };

  return (
    <Row>
      <Col style={{ display: "flex", flexDirection: "column" }}>
        <Col
          align="center"
          justify="space-between"
          style={{
            marginTop: "20px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Col>
            <ButtonOne
              text={"Tokens"}
              style={{ width: "150px" }}
              onClick={() => setLabel("tokens")}
            />
          </Col>
          <Col>
            <ButtonOne text={"NFT's"} style={{ width: "150px" }} onClick={() => setLabel("nfts")} />
          </Col>
        </Col>

        <Col style={{ height: "100px" }}>{label === "tokens" ? <Tokens /> : <Nfts />}</Col>
      </Col>
      {label === "tokens" ? (
        <div className="send-form">
          <input
            type="number"
            className="inputAddress"
            placeholder="Monto"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          <input
            type={"text"}
            className="inputAddress"
            placeholder="0x... //Dirección de billetera de destino"
            value={toAddress}
            onChange={(e) => setToAddress(e.target.value)}
          />
          <img
            src={QRLogo}
            alt={"scan qr"}
            height={30}
            width={30}
            onClick={() => setOnScanQR(true)}
          />
          <QRScanner
            data={toAddress}
            setData={setToAddress}
            onScanQR={onScanQR}
            setOnScanQR={setOnScanQR}
          />

          <Col align="center" justify="center">
            <ButtonOne
              style={{ width: "200px" }}
              text={"Enviar OPIS"}
              onClick={() => sendRunes(toAddress, amount)}
            />
          </Col>
        </div>
      ) : (
        <div className="send-form">
          <input
            type={"text"}
            className="inputAddress"
            placeholder="Dirección de contrato de la colección"
            value={collection}
            onChange={(e) => setCollection(e.target.value)}
          />
          <input
            type={"text"}
            className="inputAddress"
            placeholder="Token Id"
            value={tokenId}
            onChange={(e) => setTokenId(e.target.value)}
          />
          <input
            type={"text"}
            className="inputAddress"
            placeholder="0x... // Dirección de billetera de destino"
            value={toAddress}
            onChange={(e) => setToAddress(e.target.value)}
          />

          <Col align="center" justify="center">
            <ButtonOne
              style={{ width: "200px" }}
              text={"Enviar OPIS"}
              onClick={() => sendRunes(toAddress, amount)}
              disabled={isFetching}
            />
          </Col>
          {error && `${error}`}
        </div>
      )}
    </Row>
  );
};

export default Wallet;
